import { useTPAxios } from "@/api/useTPAxios.ts";
import { useQuery } from "@tanstack/react-query";
import { AxiosInstance, AxiosResponse } from "axios";
import type { BrandRelations } from "./brand-relations.model";

const getBrandRelations = async (
  TPAxios: AxiosInstance,
): Promise<BrandRelations> => {
  const response = await TPAxios.get<AxiosResponse<BrandRelations>>(
    '/brand-relations/brands',
  );

  return response.data.data;
}

export const useGetBrandRelations = (enabled = true) => {
  const TPAxios = useTPAxios();

  return useQuery({
    queryKey: ['brand-relations'],
    queryFn: async () => await getBrandRelations(TPAxios),
    enabled,
  });
}
